import { servicePayments } from "../servicePayments";
import { IPayeeEngagementListResponse } from "@wingspanhq/payments/dist/interfaces/api/payerPayeeEngagement";
import { ListRequestQuery } from "../../utils/serviceHelper";
import { extendConfigWithXWingspanUserHeader } from "../../shared/utils/extendHeadersWithXWingspanUser";
import { PayeeEngagementsAPIFilter } from "./getPayeeEngagementsByPayeeId";

export type PayeeEngagementListResponse = {
  data: IPayeeEngagementListResponse;
  summary: {
    listSize: number;
  };
};

export const getAllPayeeEngagements = async (
  orgPayerId?: string | undefined,
  params?: ListRequestQuery<PayeeEngagementsAPIFilter>
): Promise<PayeeEngagementListResponse> => {
  const { data, headers } = await servicePayments.get(
    `/payee/engagement`,
    extendConfigWithXWingspanUserHeader({ params }, orgPayerId)
  );

  return { summary: { listSize: Number(headers["x-ws-list-size"]) }, data };
};
